<template>
  <custome-Dialog
    :dialog-visible.sync="dialogVisible"
    :confirm-text="disabledBtn?'上传视频中':'保存'"
    :title="title"
    width="30%"
    :confirm-disable="disabledBtn"
    @confirm="confirm"
    @close="close"
  >
    <div class="content">
      <el-form
        ref="createForm"
        :model="createForm"
        :rules="creatRules"
        label-width="140px"
      >
        <el-form-item
          label="课程章节名称"
          prop="chapterName"
        >
          <el-input v-model="createForm.chapterName" />
        </el-form-item>
        <el-form-item
          label="是否收录进视频考试"
          prop="isIncludeVideoExam"
        >
          <el-radio
            v-model="createForm.isIncludeVideoExam"
            :label="1"
          >
            已收录
          </el-radio>
          <el-radio
            v-model="createForm.isIncludeVideoExam"
            :label="0"
          >
            未收录
          </el-radio>
        </el-form-item>
        <el-form-item
          v-if="createForm.pid !== -1"
          label="上传视频"
          prop="videoUrl"
        >
          <div class="video-upload">
            <upload
              :file-list.sync="createForm.videoUrl"
              type="video"
              @isProcess="getProcess"
            />
            <div />
          </div>
        </el-form-item>
      </el-form>
    </div>
  </custome-Dialog>
</template>
<script>
import customeDialog from '@/components/common/dialog.vue';
import axClient from '@/services';
import upload from '@/components/common/upload/upload.vue';

export default {
  name: 'CourseChapter',
  components: { customeDialog, upload },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    item: {
      type: [Object, null],
      default: null,
    },
  },
  data() {
    return {
      title: '修改课程章节',
      cancelText: '取消',
      disabledBtn: false,
      createForm: {
        chapterName: null,
        videoUrl: '',
        pid: null,
        id: null,
        courseId: null,
      },
      creatRules: {
        chapterName: [
          { required: true, message: '请输入课程章节名称', trigger: 'blur' },
        ],
      },
    };
  },
  watch: {
    item(val) {
      if (val) {
        const {
          chapterName,
          videoUrl,
          pid,
          id,
          courseId,
          isIncludeVideoExam,
        } = val;
        this.createForm = {
          chapterName,
          videoUrl,
          pid,
          id,
          courseId,
          isIncludeVideoExam,
        };
      }
    },
    dialogVisible(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.createForm.clearValidate();
        });
      }
    },
  },
  methods: {
    // 关闭弹窗
    close() {
      this.$emit('update:dialogVisible', false);
      this.$emit('close');
    },
    // 上传过程中
    getProcess(value) {
      this.disabledBtn = value;
    },
    confirm() {
      this.$refs.createForm.validate(async (valid) => {
        if (valid) {
          const data = await axClient.course.upsertChapter(this.createForm);
          if (!data) return;
          if (this.createForm.id) {
            this.$message.success('修改课程章节成功');
          }
          this.$emit('update:dialogVisible', false);
          this.$emit('confirm');
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  min-height: 200px;
  .wx-info {
    padding: 0 0 0 0;
    text-align: left;
    .item {
      margin-bottom: 15px;
      span {
        font-size: 12px;
        color: $--base-color-black;
        &:last-child {
          padding-left: 8px;
        }
      }
    }
  }
}

</style>
